import { Box, Banner, Typography } from "@bca/ui-library";
import { useContext } from "react";
import { ErrorContext } from "../../../context/ErrorContext";

interface CustomizableErrorBannerProps {
  title: string;
  text: string;
}

const CustomizableErrorBanner = ({
  title,
  text,
}: CustomizableErrorBannerProps) => {
  const errorContext = useContext(ErrorContext);

  return (
    <Box width="100%" marginTop={6}>
      <Banner
        title={title}
        variant="error"
        primaryLinkLabel="Dismiss"
        primaryLinkAction={() => {
          errorContext?.dispatch({ type: "clear" });
        }}
        displayMode="inline"
      >
        <Typography margin={0} variant="body">
          {text}
        </Typography>
      </Banner>
    </Box>
  );
};

export default CustomizableErrorBanner;
